import React, { useState, useEffect } from "react";

function Home() {
    const [netProfit, setnetProfit] = useState(null);
    const [totalItems, settotalItems] = useState(null);
    const [totalSales, settotalSales] = useState(null);
    const [recent, setrecent] = useState(null);


    useEffect(() => {
        const fetchData = async () => {
            const match = document.cookie.match(new RegExp("(^| )token=([^;]+)"));
    
            try {
                const response = await fetch("https://liquidationapi.dallasagsmith.workers.dev/dashboard", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        token: match[2],
                    }),
                });
    
                if (response.status === 200) 
                {
                    const data = await response.json();
                    console.log(data);
                    setnetProfit(`$${data.net.net_profit ? data.net.net_profit.toFixed(2) : 0.00}`);
                    console.log(data.net.net_profit);
                    settotalItems(data.items);
                    settotalSales(data.sales);
                    setrecent(data.recent);
                }
    
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
    
        fetchData();
      }, []);

    return (
        <div className="page-container">
        <h2>Dashboard</h2>
        <div className="card">
            <h3>Net Profit</h3>
            { netProfit === null ? <div className="spinner"></div> :
            (parseFloat(netProfit.replace("$", ""))) >= 0 ? 
            <h3 style={{color: "green"}}>{netProfit}</h3> : 
            <h3 style={{color: "red"}}>{netProfit}</h3>
            }
        </div>
        <div className="card">
            <h3>Items For Sale</h3>
            { totalItems === null ? <div className="spinner"></div> : <h3>{totalItems}</h3>}
        </div>
        <div className="card">
            <h3>Items Sold</h3>
            { totalSales === null ? <div className="spinner"></div> : <h3>{totalSales}</h3>}
        </div>
        <div className="card">
            <h3>Recent Transactions</h3>
            <div class="transaction-list" id="transactionList">
                {recent === null ? <div className="spinner"></div> : recent.map((item, index) => (
                    <div className="transaction-card" key={index}>
                        <div className="transaction-info">
                            <div className="transaction-title">{item.title}</div>
                            <div className="transaction-desc">{item.description}</div>
                            <div className="transaction-dates">{item.sold_date}</div>
                        </div>
                        <div className="transaction-amounts">
                            {item.sell > 0 ? ((item.sell - item.cost) >= 0 ? (<div className="transaction-cost" style={{color: "green"}}>+{(((item.sell - item.cost) / item.cost) * 100).toFixed(2)}%</div>) : (<div className="transaction-cost" style={{color: "red"}}>{(((item.sell - item.cost) / item.cost) * 100).toFixed(2)}%</div>)) : ''}

                            <div className="transaction-sell">{item.sell > 0 ? `Sell: $${Number(item.sell).toFixed(2)}` : 'DONATION'}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
        </div>
    );
}

export default Home;
